// Contact modal dispatcher. Keeps the original default export + props so its
// call site (SupportButton) is unchanged, and renders the live-chat arm
// selected by VITE_BOOKING_CHAT:
//
//   intercom (default) → IntercomChatModal (useIntercom)
//   ella               → EllaChatModal (the hosted chat.aheadhealth.com embed)
//
// The env check is written inline (not the readBookingChat() helper) so Vite
// constant-folds it: the untaken arm tree-shakes out of the production bundle.
// Because the branch is a build-time constant, only one arm's hooks are ever in
// the tree (no rules-of-hooks issue). Shared layout lives in ContactModalView.

import { BookingLanguage } from "@/types/booking";
import IntercomChatModal from "@/components/IntercomChatModal";
import EllaChatModal from "@/components/EllaChatModal";

interface ContactModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  language: BookingLanguage;
}

const ContactModal = ({ open, onOpenChange, language }: ContactModalProps) => {
  if (import.meta.env.VITE_BOOKING_CHAT === "ella") {
    return (
      <EllaChatModal
        open={open}
        onOpenChange={onOpenChange}
        language={language}
      />
    );
  }
  return (
    <IntercomChatModal
      open={open}
      onOpenChange={onOpenChange}
      language={language}
    />
  );
};

export default ContactModal;
